import filesApi from '.'
import { getAuthHeaders } from 'utils/requests'

// folderId null/undefined = tira o arquivo da pasta (volta pra raiz)
const moveFile = async (id, folderId) => {
  const headers = { headers: getAuthHeaders() }
  return await filesApi.patch(`/${id}/move`, { folderId: folderId || null }, headers)
}

export default moveFile
